import React, { FC } from 'react';
import Form from 'components/Form';

import { PifpafPageProps } from './models';

import 'styles/main.scss';
import './styles.scss';

const Pifpaf: FC<PifpafPageProps> = ({ pageContext, location }) => (
  <Form {...{ ...pageContext, location }} />
);

export default Pifpaf;
